import getConsumerMailboxOperation from 'owa-service/lib/operation/getConsumerMailboxOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function getConsumerMailboxOptions() {
    return getConsumerMailboxOperation({
        Header: getJsonRequestHeader(),
    }).then(function (response) {
        return response.Options;
    });
}
//# sourceMappingURL=getConsumerMailboxOptions.js.map